<div class="se-side-nav-class" *ngIf="show">
    <div class="se-side-nav-main-container" 
         
         style="display: flex; overflow: auto">
        <mat-tab-group #matTabGroup
                       mat-stretch-tabs
                       class="se-side-tab-group se-tab-fill-height"
                       [ngClass]="{'se-side-nav-icon-selected__clicked': hideContent}"
                       (selectedTabChange)="onSelectedTabChange($event)">
            <mat-tab *ngFor="let sideComponent of activeSideComponents$ | async; let index = index; let last = last;">
                <ng-template mat-tab-label>
                    <div (click)="onClick(index)" class="icon-container_click">
                        <mat-icon class="sidenav-icon" [matTooltip]="sideComponent.title | translate">{{sideComponent.icon}}</mat-icon>
                    </div>
                </ng-template>

                <div class="se-side-nav-component-container" [ngClass]="!hideContent ? 'side-tab-open' : 'side-tab-close'">
                    <header class="se-side-nav-header">{{sideComponent.title | translate}}</header>
                    <div class="se-side-nav-header__dividing-line"></div>
                    <div [ngSwitch]="sideComponent.type"
                         class="se-side-nav-component-container"
                         style="overflow-y: auto; overflow-x: hidden;">
                        <se-side-patient-history *ngSwitchCase="sideComponentType.patientHistory"
                                                 style="width: 100%">
                        </se-side-patient-history>
                        <se-side-key-images-container *ngSwitchCase="sideComponentType.keyImagesPreview"
                                                      class="se-side-nav-component-container__key-images">
                        </se-side-key-images-container>
                        <ng-container #reportingContainer *ngSwitchCase="sideComponentType.reporting">
                        </ng-container>
                        <se-side-details *ngSwitchCase="sideComponentType.details"
                                         style="width: 100%; height:100%">
                        </se-side-details>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
